import React, { CSSProperties } from 'react';
import { ListItem, ListItemAvatar, ListItemText, Divider } from '@material-ui/core';
import { Litros, Reais } from '../../components/numberUtils';
import { AvatarCombustivel } from '../../components/avatarCombustivel';
import { KPIComparativo } from '../dashboard/KPIComparativo';
import { Venda } from '../../models/venda';

export interface ListItemCombustivelProps {
  vendaCombustivel: Venda;
  comparativo?: Venda;
  layout?: ListItemCombustivelLayout;
}

export enum ListItemCombustivelLayout { PorQuantidade, PorValor };

export const ListItemCombustivel = (props: ListItemCombustivelProps) => {
  const {
    layout = ListItemCombustivelLayout.PorValor
  } = props;

  const porValor = layout === ListItemCombustivelLayout.PorValor;
  const styleDestaque: CSSProperties = { fontSize: '1.1rem', fontWeight: 'bold' };
  const widgetQuantidade = <Litros style={!porValor ? { ...styleDestaque } : undefined} valor={props.vendaCombustivel.quantidade} />;
  const widgetValor = <Reais style={porValor ? { ...styleDestaque } : undefined} valor={props.vendaCombustivel.totalLiquido} />;

  const baseComparativo = props.comparativo ? (porValor ? props.vendaCombustivel.totalLiquido : props.vendaCombustivel.quantidade) : undefined;
  const valorComparativo = props.comparativo ? (porValor ? props.comparativo.totalLiquido : props.comparativo.quantidade) : undefined;

  return <div key={props.vendaCombustivel.codigo}>
    <ListItem>
      <ListItemAvatar>
        <AvatarCombustivel combustivelSigla={props.vendaCombustivel.sigla!} />
      </ListItemAvatar>
      <ListItemText secondary={<span>{props.vendaCombustivel.contagem} venda(s)</span>} >
        {porValor ? widgetQuantidade : widgetValor}
      </ListItemText>
      <ListItemText style={{ textAlign: 'right' }} secondary={props.comparativo ? <KPIComparativo valorBase={baseComparativo!} valor={valorComparativo!} /> : undefined}>
        {porValor ? widgetValor : widgetQuantidade}
      </ListItemText>
    </ListItem>
    <Divider />
  </div>;
};